import { useTranslate } from "@tolgee/react";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { useRouterState } from "@tanstack/react-router";
import { syncDocumentSeo } from "#/lib/seo";
import { localeAtom } from "#/stores/locale-store";

export function SeoSync() {
	const locale = useAtomValue(localeAtom);
	const { t } = useTranslate();
	const pathname = useRouterState({
		select: (state) => state.location.pathname,
	});

	useEffect(() => {
		syncDocumentSeo({
			locale,
			pathname,
			t,
		});
	}, [locale, pathname, t]);

	return null;
}
